module.exports = __webpack_public_path__ + "img/add-svgrepo-com.f6ba2ef0.svg";